import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SwitchGrid = styled(Grid)`
  margin-left: -15px;
`;